import { AfterViewInit, Component, Input, OnDestroy, OnInit, TemplateRef, AfterContentInit, ContentChildren, QueryList, AfterContentChecked, ElementRef, Renderer2, EventEmitter, Output } from '@angular/core';
import {  v4 as uuidv4 } from 'uuid';
import { TabComponent } from '../tab/tab.component';
import { delay } from 'lodash';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit, AfterContentChecked {
	 
	@Input() tabs : { label : string; active? : boolean }[] = [];

	@ContentChildren (TabComponent) inputTabs: QueryList<TabComponent>;
	@Output() tabActivated : EventEmitter<number> = new EventEmitter<number>();	
	
	compTabs : TabComponent[] = [];

	componentId : string = uuidv4();

	private inputTabsChangesSub : Subscription;

	constructor(private cdRef: ChangeDetectorRef,
		private renderer: Renderer2, 
		private elementRef: ElementRef,
		private cdr: ChangeDetectorRef)

	{
		
	}

	ngOnInit(): void {
		
	}

	ngOnDestroy(): void {
		
	}

	ngAfterViewInit(): void {
		
	}

	ngAfterContentInit(): void {
		const activeTabs = this.inputTabs?.filter((tab : TabComponent) => tab.active);
		if(this.inputTabs?.length && 0 === activeTabs.length || 1 < activeTabs.length)	
		{
			this.selectTab(0);
		}
	}

	ngAfterContentChecked(): void {		
		this.compTabs = this.inputTabs?.toArray();
	}

	onTabClicked = (event : any, index : number) => 
	{
		event?.preventDefault();
		"function" === typeof(event.stopPropogation) && event.stopPropogation();		
		"function" === typeof(event.stopImmediatePropagation) && event.stopImmediatePropagation();		
		this.selectTab(index);
	}

	private selectTab = (index : number) => {
		const tabs = this.inputTabs?.toArray();
		
		tabs?.forEach((tab : TabComponent) => tab.active = false);
		tabs[index].active = true;	

		this.tabActivated.emit(index);
		this.cdr.detectChanges();			
	}

	get activeTabs() {
		return this.inputTabs?.filter((tab : TabComponent) => tab.template && tab.active);
	}
}
